<template>
  <div>
    <h6 v-if="data.length == 0" class="title-pages">HOSPEDAGEM</h6>
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length == 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <!-- show-select -->
      <!-- v-model="selected" -->
      <v-data-table
        v-show="data.length > 0"
        dense
        :headers="headers"
        item-key="resident_has_accommodation_item_id"
        :items="data"
        :expanded.sync="expanded"
        show-expand
        :footer-props="{
          'items-per-page-options': [5],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title
              ><h1 class="title-pages">HOSPEDAGEM</h1></v-toolbar-title
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div
            v-if="item.resident_has_accommodation_item_status == 0"
            class="d-flex align-items-center"
          >
            <span>FATURADO</span>
            <v-icon class="ml-2" small color="success">
              mdi-check-circle-outline
            </v-icon>
          </div>
          <div v-else class="d-flex align-items-center">
            <span>FATURAMENTO PENDENTE</span>
            <v-icon class="ml-2" small color="orange">
              mdi-information-outline
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.resident_has_accommodation_item_value) }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ handleType(item.type) }}
        </template>
        <template v-slot:[`item.total_value`]="{ item }">
          {{ formatReal(item.total_value) }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="m-0 p-0" :colspan="headers.length">
            <item-details :item="item" />
          </td>
        </template>
      </v-data-table>
      <div v-if="data.length > 0" class="text-right mt-2">
        <h1 class="title-pages">TOTAL: R$ {{ formatReal(total_value) }}</h1>
      </div>
      <ErrorsMessages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import ItemDetails from "./hosting-details.vue";

import {
  professionalClassCouncilValue,
  formatReal,
} from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "Hosting",

  components: {
    ErrorsMessages,
    ItemDetails,
  },

  props: {
    loading: Boolean,
    resident_id: [Number, String],
    data: Array,
    total_value: [Number, String],
    start: String,
    end: String,
  },

  data() {
    return {
      selected: [],
      expanded: [],

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "TIPO", value: "type", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "TOTAL FINAL", value: "total_value", sortable: false },
      ],

      errors: [],
    };
  },

  watch: {
    selected() {
      let ids = this.selected.map(({ id }) => id);
      this.$emit("selected", { type: "hosting", ids });
    },
  },

  methods: {
    moment,
    formatReal,
    professionalClassCouncilValue,

    handleType(type) {
      return (
        {
          DIARIA: "DIÁRIA",
          MENSAL: "MENSAL",
        }[type] || "NÃO ENCONTRADO"
      );
    },
  },
};
</script>